<template>
  <div
    class="multiselect-wrapper"
    :class="{
      'has-error': !!isError,
    }"
  >
    <multiselect
      ref="ms"
      class="col p-0"
      :class="{
        required: isRequired,
        'is-invalid': !!isError,
      }"
      :value="value"
      :options="options"
      :multiple="false"
      :placeholder="placeholder"
      :track-by="trackBy"
      :custom-label="customLabel || productLabel"
      :selectLabel="selectLabel"
      :selectedLabel="selectedLabel"
      :deselectLabel="deselectLabel"
      :disabled="disabled"
      :allow-empty="allowEmpty"
      :clear-on-select="clearOnSelect"
      :close-on-select="closeOnSelect"
      openDirection="below"
      @open="onOpen"
      @input="$emit('input', $event)"
    >
      <span slot="noResult">{{ noResultLabel }}</span>
    </multiselect>
  </div>
</template>

<script>
export default {
  name: "MultipleSelectField",
  props: {
    isRequired: {
      default: false,
    },
    value: {
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    isError: {
      default: false,
    },
    placeholder: {
      type: String,
      default: "เลือกสินค้า",
    },
    trackBy: {
      type: String,
      default: "productId",
    },
    customLabel: {
      type: Function,
      default: null,
    },
    selectLabel: {
      type: String,
      default: "เลือกสินค้า",
    },
    selectedLabel: {
      type: String,
      default: "เลือกแล้ว",
    },
    deselectLabel: {
      type: String,
      default: "คลิกเพื่อลบออก",
    },
    noResultLabel: {
      type: String,
      default: "ไม่พบรายการ",
    },
    disabled: {
      default: false,
    },
    allowEmpty: {
      default: true,
    },
    showErrorIcon: {
      default: true,
    },
    clearOnSelect: {
      default: true,
    },
    closeOnSelect: {
      default: true,
    },
  },
  methods: {
    productLabel(item) {
      if (!item) return "";
      return `${item.productCode} - ${item.productNameMain}`;
    },
    onOpen() {
      const dropdown = this.$refs.ms.$refs.list;
      const applyPosition = () => {
        if (!dropdown) return;
        const rect = this.$el.getBoundingClientRect();
        dropdown.style.position = "fixed";
        dropdown.style.top = rect.bottom + "px";
        dropdown.style.left = rect.left + "px";
        dropdown.style.width = rect.width + "px";
        dropdown.style.minWidth = rect.width + "px";
        dropdown.style.zIndex = "9999";
      };
      applyPosition();
      this.$emit("open");
      requestAnimationFrame(applyPosition);
    },
  },
};
</script>

<style scoped>
.multiselect-wrapper {
  position: relative;
}

.multiselect-invalid-icon {
  position: absolute;
  top: 50%;
  right: 36px;
  transform: translateY(-50%);
  pointer-events: none;
  z-index: 1;
  width: 20px;
  height: 20px;
}

.multiselect-wrapper.has-error ::v-deep .multiselect {
  border-color: #dc3545;
}

::v-deep .multiselect.is-invalid {
  border-color: #dc3545;
}

.required {
  background-color: #ccecff6c;
}

::v-deep .multiselect__tags {
  background-color: transparent;
}

::v-deep .multiselect__select {
  background-color: transparent;
}

.multiselect-wrapper .multiselect--disabled {
  background-color: transparent;
}

::v-deep .multiselect--disabled .multiselect__tags {
  background-color: #e8e8e8;
  border-color: #dee2e6 !important;
}

::v-deep .multiselect--disabled .multiselect__select {
  background-color: transparent;
}

::v-deep .multiselect--disabled .multiselect__select::before {
  border-color: #c6c6c6 transparent transparent;
}

::v-deep .multiselect__single,
::v-deep .multiselect__input,
::v-deep .multiselect__placeholder {
  background-color: transparent !important;
}

::v-deep .multiselect--disabled span.multiselect__placeholder {
  margin-left: 6px !important;
  color: #c6c6c6 !important;
  border-color: #dee2e6 !important;
}

::v-deep .multiselect__input,
::v-deep .multiselect__single {
  padding-left: 6px;
}

::v-deep span.multiselect__single {
  margin-left: 6px !important;
}

::v-deep .multiselect__single {
  margin-bottom: 0;
  padding-left: 0;
  white-space: normal;
  word-break: break-word;
  overflow: visible;
  text-overflow: unset;
}
</style>
